import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

interface Slide {
  image: string;
  badge: string;
  title: string;
  summary: string;
  to: string;
}

const slides: Slide[] = [
  {
    image:
      'https://readdy.ai/api/search-image?query=Epic%20fantasy%20snowy%20northern%20city%20at%20night%20with%20glowing%20golden%20lanterns%20tall%20white%20towers%20and%20aurora%20in%20a%20deep%20blue%20sky%2C%20cinematic%20wide%20anime%20game%20promotional%20illustration%20soft%20light&width=1600&height=900&seq=hero-620&orientation=landscape',
    badge: '6.2 版本 · 霜夜与誓约',
    title: '至冬国首张大地图「白匣城」正式开放',
    summary: '全新冰系五星角色、世界任务与秘境挑战同步上线，版本前瞻与攻略一网打尽。',
    to: '/detail/news-6-2-release',
  },
  {
    image:
      'https://readdy.ai/api/search-image?query=Group%20of%20fantasy%20anime%20heroes%20standing%20together%20with%20glowing%20elemental%20magic%2C%20soft%20bokeh%20particles%2C%20warm%20and%20cool%20contrast%20lighting%2C%20clean%20cinematic%20game%20promotional%20art%20wide%20composition&width=1600&height=900&seq=hero-chars&orientation=landscape',
    badge: '角色攻略大全',
    title: '16 位热门角色培养攻略一次看够',
    summary: '从元素反应到配队思路，深入解析角色技能机制，助你组建属于自己的最强队伍。',
    to: '/characters',
  },
  {
    image:
      'https://readdy.ai/api/search-image?query=Ancient%20glowing%20stone%20gate%20opening%20above%20clouds%20with%20golden%20light%20rays%2C%20epic%20fantasy%20anime%20game%20key%20visual%20wide%20cinematic%20composition%20soft%20atmosphere&width=1600&height=900&seq=hero-updates&orientation=landscape',
    badge: '版本更新记录',
    title: '版本补丁说明与玩法改动全记录',
    summary: '集中整理每个版本的更新内容、系统调整与活动安排，快速掌握版本变化。',
    to: '/updates',
  },
];

export default function HeroCarousel() {
  const [index, setIndex] = useState(0);
  const total = slides.length;

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % total);
    }, 5200);
    return () => clearInterval(timer);
  }, [total]);

  return (
    <section className="relative w-full overflow-hidden" aria-label="焦点推荐">
      <div
        className="flex transition-transform duration-700 ease-out"
        style={{ transform: `translateX(-${index * 100}%)` }}
      >
        {slides.map((slide) => (
          <div key={slide.to} className="relative h-[460px] w-full flex-shrink-0 md:h-[560px]">
            <img
              src={slide.image}
              alt={slide.title}
              className="absolute inset-0 h-full w-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/45 to-black/20"></div>
            <div className="absolute inset-0 flex items-center">
              <div className="w-full px-6 md:px-12 lg:px-20">
                <div className="max-w-2xl">
                  <span className="inline-flex items-center gap-2 rounded-full bg-accent-500 px-3.5 py-1.5 text-xs font-semibold text-white">
                    <i className="ri-fire-line"></i>
                    {slide.badge}
                  </span>
                  <h1 className="mt-5 font-heading text-3xl font-bold leading-tight text-white md:text-5xl">
                    {slide.title}
                  </h1>
                  <p className="mt-4 max-w-xl text-sm leading-relaxed text-white/85 md:text-base">
                    {slide.summary}
                  </p>
                  <div className="mt-7 flex flex-wrap items-center gap-3">
                    <Link
                      to={slide.to}
                      className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-white transition-colors hover:bg-primary-600"
                    >
                      立即查看
                      <i className="ri-arrow-right-line"></i>
                    </Link>
                    <Link
                      to="/news"
                      className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-white/40 px-5 py-2.5 text-sm font-medium text-white backdrop-blur-sm transition-colors hover:bg-white/15"
                    >
                      浏览全部资讯
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      <button
        type="button"
        aria-label="上一张"
        onClick={() => setIndex((prev) => (prev - 1 + total) % total)}
        className="absolute left-3 top-1/2 hidden h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full border border-white/40 text-white backdrop-blur-sm transition-colors hover:bg-white/15 md:flex"
      >
        <i className="ri-arrow-left-s-line text-xl"></i>
      </button>
      <button
        type="button"
        aria-label="下一张"
        onClick={() => setIndex((prev) => (prev + 1) % total)}
        className="absolute right-3 top-1/2 hidden h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full border border-white/40 text-white backdrop-blur-sm transition-colors hover:bg-white/15 md:flex"
      >
        <i className="ri-arrow-right-s-line text-xl"></i>
      </button>

      <div className="absolute bottom-6 left-1/2 flex -translate-x-1/2 items-center gap-2">
        {slides.map((slide, i) => (
          <button
            key={slide.to}
            type="button"
            aria-label={`切换到第 ${i + 1} 张`}
            onClick={() => setIndex(i)}
            className={`h-2 rounded-full transition-all ${
              i === index ? 'w-7 bg-accent-500' : 'w-2 bg-white/60 hover:bg-white'
            }`}
          ></button>
        ))}
      </div>
    </section>
  );
}